/**
 * 移动端售后接口相关api
 */
import request from '@/utils/request'

/**
 * 真伪查询
 * @param query
 * @returns {*}
 */
export function checkPortal(keyWord) {
    return request({
        url: '/userClient/sales/checkPortal',
        method: 'post',
        data: { keyWord }
    })
}
/**
 * NFC真伪查询
 * @param query
 * @returns {*}
 */
export function checkPortalNfc(keyWord) {
    return request({
        url: '/userClient/home/checkPortalNfc',
        method: 'post',
        data: { keyWord }
    })
}

/**
 * 售后进度查询
 * @param query
 * @returns {*}
 */
export function progress(keyWord) {
    return request({
        url: '/userClient/sales/progress',
        method: 'post',
        data: { keyWord }
    })
}

/**
 * 售后申请
 * @param formData
 * @returns {*}
 */
export function afterPost(formData) {
    return request({
        url: '/userClient/sales/afterPost',
        method: 'post',
        data: formData
    })
}

/**
 * 球杆登记
 * @param formData
 * @returns {*}
 */
export function relation(formData) {
    return request({
        url: '/userClient/sales/relation',
        method: 'post',
        data: formData
    })
}

/**
 * 获取当前登录人名下注册登记的球杆
 * @param
 * @returns {*}
 */
export function productByUser() {
    return request({
        url: '/userClient/sales/productByUser',
        method: 'get',
    })
}

/**
 * 获取当前登录人名下注册登记的球杆
 * @param
 * @returns {*}
 */
export function benefitsByUser() {
    return request({
        url: '/userClient/sales/benefitsByUser',
        method: 'get',
    })
}

/**
 * 取消权益
 * @param
 * @returns {*}
 */
export function cancelBenefits(businessId) {
    return request({
        url: '/userClient/sales/cancelBenefits',
        method: 'post',
        data: {businessId}
    })
}

/**
 * 会员注册
 * @param formData
 * @returns {*}
 */
export function memberRegister(formData) {
    return request({
        url: '/userClient/memberUser/register',
        method: 'post',
        data: formData
    })
}



/**
 * 会员登录
 * @param formData
 * @returns {*}
 */
export function memberLogin(formData) {
    return request({
        url: '/userClient/memberUser/login',
        method: 'post',
        data: formData
    })
}

/**
 * 登录获取验证码
 * @param formData
 * @returns {*}
 */
export function sendCode(phoneNumber,type) {
    return request({
        url: '/userClient/memberUser/sendCode',
        method: 'get',
        params: {phoneNumber:phoneNumber,type:type}
    })
}

/**
 * 修改密码校验验证码
 * @returns {*}
 */
export function updatePasswordToVerify(formData) {
    return request({
        url: '/userClient/memberUser/updatePasswordToVerify',
        method: 'post',
        data: formData
    })
}


/**
 * 修改密码校验验证码
 * @returns {*}
 */
export function updatePassword(formData) {
    return request({
        url: '/userClient/memberUser/updatePassword',
        method: 'post',
        data: formData
    })
}
/**
 * 登录我的球杆列表
 * @param formData
 * @returns {*}
 */
export function benefitsByNumber(number) {
    return request({
        url: '/userClient/sales/benefitsByNumber',
        method: 'get',
        params: {number}
    })
}

/**
 * 支持登记品牌下拉框
 * @returns {*}
 */
export function brandDropDown() {
    return request({
        url: '/userClient/memberUser/brandDropDown',
        method: 'get',
    })
}


/**
 * 球杆福利置换提交
 * @param formData
 * @returns {*}
 */
export function benefitsSubmit(formData) {
    return request({
        url: '/userClient/sales/benefitsSubmit',
        method: 'post',
        data: formData
    })
}

//根据球杆编码获取产品信息
export function registerByNumber(number) {
    return request({
        url: '/userClient/memberUser/registerByNumber',
        method: 'get',
        params: {number}
    })
}

//真伪查询会员查询次数
export function checkPortalByMemberCount() {
    return request({
        url: '/userClient/sales/checkPortalByMemberCount',
        method: 'get',
    })
}

//球杆解绑--代理商
export function unbindByNumber(formData) {
    return request({
        url: '/userClient/salesAgent/unbindByNumber',
        method: 'post',
        data: formData
    })
}

//球杆解绑--普通会员
export function userUnbindByNumber(formData) {
    return request({
        url: '/userClient/sales/unbindByNumber',
        method: 'post',
        data: formData
    })
}
